import { override } from 'flarum/common/extend';
import PostStreamState from 'flarum/forum/states/PostStreamState';

/** Streams whose loading is held by the page pager: scrolling and «load more» must not pull in the next posts. */
const held = new WeakSet();

/**
 * Makes PostStreamState's `_loadNext` / `_loadPrevious` do nothing for a held stream. Core builds `loadNext` and
 * `loadPrevious` of every stream from these two prototype methods when the stream is created, so this has to run
 * before the first discussion opens (the forum initializer does it).
 */
export function installStreamGuard() {
  override(PostStreamState.prototype, '_loadNext', function (original) {
    if (held.has(this)) return;
    return original();
  });
  override(PostStreamState.prototype, '_loadPrevious', function (original) {
    if (held.has(this)) return;
    return original();
  });
}
export function holdStream(stream) {
  held.add(stream);
  stream.paused = true;
}
export function releaseStream(stream) {
  held.delete(stream);
  stream.paused = false;
}
flarum.reg.add('forumaker-magicread', 'forum/components/streamGuard', { installStreamGuard: installStreamGuard,holdStream: holdStream,releaseStream: releaseStream, });